export const SET_RESTAURANT_ORDERING_MODES = 'set_restaurant_ordering_modes';
